export const fetchBlogCategories = resp => ({
  type: "FETCH_BLOG_CATEGORIES",
  payload: resp
});

export const fetchBlogTypes = resp => ({
  type: "FETCH_BLOG_TYPES",
  payload: resp
});

export const fetchBlogThemes = resp => ({
  type: "FETCH_BLOG_THEMES",
  payload: resp
});

export const fetchMediaCategories = resp => ({
  type: "FETCH_MEDIA_CATEGORIES",
  payload: resp
});

export const fetchMediaTypes = resp => ({
  type: "FETCH_MEDIA_TYPES",
  payload: resp
});

export const fetchEventCategories = resp => ({
  type: "FETCH_EVENT_CATEGORIES",
  payload: resp
});

export const fetchEventTypes = resp => ({
  type: "FETCH_EVENT_TYPES",
  payload: resp
});

export const fetchEmailingCategories = resp => ({
  type: "FETCH_EMAILING_CATEGORIES",
  payload: resp
});

export const fetchEmailingTypes = resp => ({
  type: "FETCH_EMAILING_TYPES",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/filter.js